import AuditDiffWorker from "@/components/auditLog/auditDiff.worker?worker";
import type {
  AuditWorkerCommand,
  AuditWorkerResult,
} from "@/components/auditLog/auditLogTypes";

export function createAuditDiffClient() {
  const worker = new AuditDiffWorker();
  let nextId = 0;
  const pending = new Map<
    number,
    {
      resolve: (value: AuditWorkerResult) => void;
      reject: (reason: Error) => void;
    }
  >();
  const failAll = () => {
    pending.forEach(({ reject }) =>
      reject(new Error("Audit diff worker unavailable"))
    );
    pending.clear();
  };
  worker.onmessage = (
    event: MessageEvent<{ id: number; result: AuditWorkerResult }>
  ) => {
    const request = pending.get(event.data.id);
    pending.delete(event.data.id);
    if (event.data.result.type === "error")
      request?.reject(new Error("Cannot prepare audit diff"));
    else request?.resolve(event.data.result);
  };
  worker.onerror = failAll;
  return {
    request: (command: AuditWorkerCommand) =>
      new Promise<AuditWorkerResult>((resolve, reject) => {
        const id = ++nextId;
        pending.set(id, { resolve, reject });
        worker.postMessage({ id, command });
      }),
    dispose: () => {
      worker.terminate();
      failAll();
    },
  };
}

export type AuditDiffClient = ReturnType<typeof createAuditDiffClient>;
